<button
	(click)="openPostLoadDialog()"
	*ngIf="!isDuplicateLoad && !isEditQuote"
	color="primary"
	mat-raised-button
>
	<mat-icon style="margin-right: 1rem">event_note</mat-icon>
	<span>Post a Load</span>
</button>

<button
	(click)="$event.stopPropagation(); openPostLoadDialog()"
	*ngIf="isDuplicateLoad"
	mat-icon-button
>
	<mat-icon class="primary-light-color">file_copy</mat-icon>
</button>

<button
	(click)="$event.stopPropagation(); openPostLoadDialog()"
	*ngIf="isEditQuote"
	color="primary"
	mat-raised-button
>
	<mat-icon style="margin-right: 1rem">edit</mat-icon>
	<span>Edit Load</span>
</button>
